import { render, staticRenderFns } from "./TicketStatusPill.vue?vue&type=template&id=32f21657&scoped=true&"
import script from "./TicketStatusPill.vue?vue&type=script&lang=js&"
export * from "./TicketStatusPill.vue?vue&type=script&lang=js&"
import style0 from "./TicketStatusPill.vue?vue&type=style&index=0&id=32f21657&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f21657",
  null
  
)

export default component.exports